// Perfil
export { default as Perfil } from './perfil/TutorialPerfil';

// Mapeamento
export { default as CadastroComportamental } from './mapeamento/TutorialCadastroComportamental';
export { default as NormalizacaoComportamental } from './mapeamento/TutorialNormalizacaoComportamental';
export { default as CadastroResponsabilidade } from './mapeamento/TutorialCadastroResponsabilidade';
export { default as NormalizacaoResponsabilidade } from './mapeamento/TutorialNormalizacaoResponsabilidade';
export { default as ValidacaoResponsabilidade } from './mapeamento/TutorialValidacaoResponsabilidade';
export { default as ConsolidacaoResponsabilidade } from './mapeamento/TutorialConsolidacaoResponsabilidade';

// Diagnostico
export { default as Autoavaliacao } from './diagnostico/TutorialAutoavaliacao';
export { default as AvaliacaoGestor } from './diagnostico/TutorialAvaliacaoGestor';
export { default as AvaliacaoEquipe } from './diagnostico/TutorialAvaliacaoEquipe';
export { default as AvaliacaoPares } from './diagnostico/TutorialAvaliacaoPares';
export { default as AutoavaliacaoResponsabilidade } from './diagnostico/TutorialAutoavaliacaoResponsabilidade';
export { default as AvaliacaoEquipeResponsabilidadeGestorUnidade }
  from './diagnostico/TutorialAvaliacaoEquipeResponsabilidadeGestorUnidade';
export { default as AvaliacaoEquipeResponsabilidadeGestorUnidades }
  from './diagnostico/TutorialAvaliacaoEquipeResponsabilidadeGestorUnidades';

// Desempenho
export { default as DesempenhoComportamental } from './desempenho/TutorialDesempenhoComportamental';
export { default as DesempenhoResponsabilidade } from './desempenho/TutorialDesempenhoResponsabilidade';
export { default as CoeficienteDesempenho } from './desempenho/TutorialCoeficienteDesempenho';

// Monitoramento do Mapeamento
export { default as MonitoramentoMapeamentoEstruturaUnidades }
  from './monitoramento/mapeamento/TutorialMonitoramentoMapeamentoEstruturaUnidades';
export { default as MonitoramentoMapeamentoUnidadeComportamental }
  from './monitoramento/mapeamento/TutorialMonitoramentoMapeamentoUnidadeComportamental';
export { default as MonitoramentoMapeamentoGeralComportamental }
  from './monitoramento/mapeamento/TutorialMonitoramentoMapeamentoGeralComportamental';
export { default as MonitoramentoMapeamentoUnidadeResponsabilidade }
  from './monitoramento/mapeamento/TutorialMonitoramentoMapeamentoUnidadeResponsabilidade';
export { default as MonitoramentoMapeamentoGeralResponsabilidade }
  from './monitoramento/mapeamento/TutorialMonitoramentoMapeamentoGeralResponsabilidade';

// Monitoramento do Diagnóstico
export { default as MonitoramentoDiagnosticoComportamental }
  from './monitoramento/diagnostico/TutorialMonitoramentoDiagnosticoComportamental';
export { default as MonitoramentoDiagnosticoTecnico }
  from './monitoramento/diagnostico/TutorialMonitoramentoDiagnosticoTecnico';

// Monitoramento do Desempenho
export { default as MonitoramentoDesempenhoUnidadeComportamental }
  from './monitoramento/desempenho/TutorialMonitoramentoDesempenhoUnidadeComportamental';
export { default as MonitoramentoDesempenhoGeralComportamental }
  from './monitoramento/desempenho/TutorialMonitoramentoDesempenhoGeralComportamental';
export { default as MonitoramentoDesempenhoUnidadeResponsabilidade }
  from './monitoramento/desempenho/TutorialMonitoramentoDesempenhoUnidadeResponsabilidade';
export { default as MonitoramentoDesempenhoGeralResponsabilidade }
  from './monitoramento/desempenho/TutorialMonitoramentoDesempenhoGeralResponsabilidade';
export { default as MonitoramentoCoeficienteDesempenhoUnidade }
  from './monitoramento/desempenho/TutorialMonitoramentoCoeficienteDesempenhoUnidade';
export { default as MonitoramentoCoeficienteDesempenhoGeral }
  from './monitoramento/desempenho/TutorialMonitoramentoCoeficienteDesempenhoGeral';

// Monitoramento do Perfil
export { default as MonitoramentoPerfilFiltrosBusca }
  from './monitoramento/perfil/TutorialMonitoramentoPerfilFiltrosBusca';
export { default as MonitoramentoPerfilRelatoriosGerenciais }
  from './monitoramento/perfil/TutorialMonitoramentoPerfilRelatoriosGerenciais';
